import React from 'react';
import { componentVariants } from '../../config';

const Alert = ({ type = 'info', title, message, onClose, className = '' }) => {
  const { base, types } = componentVariants.alert;
  const currentType = types[type];

  return (
    <div className={`${base} ${currentType.container} ${className}`} role="alert">
      <div className="flex">
        <div className="flex-shrink-0">
          <span className={`text-sm font-medium ${currentType.iconColor}`}>
            {currentType.icon}
          </span>
        </div>
        <div className="ml-3 flex-1">
          {title && (
            <h3 className="text-sm font-medium">
              {title}
            </h3>
          )}
          {message && (
            <div className={`text-sm ${title ? 'mt-1' : ''}`}>
              {message}
            </div>
          )}
        </div>
        {onClose && (
          <div className="ml-auto pl-3">
            <button
              onClick={onClose}
              className={`inline-flex rounded-md p-1.5 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 ${currentType.iconColor}`}
            >
              <span className="sr-only">Dismiss</span>
              <span className="text-sm">×</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Alert;
